<template>

    <!-- Common Banner Area -->
    <FlightConfirmationBanner />

    <!-- Flight Confirmation Submission Areas -->
    <FlightConfirmation />

</template>
<script>
import FlightConfirmationBanner from '@/components/flight-confirmation/FlightConfirmationBanner.vue'
import FlightConfirmation from '@/components/flight-confirmation/FlightConfirmation.vue'

export default {
    name: "FlightConfirmationView",
    components: {
        FlightConfirmationBanner, FlightConfirmation
    }
};
</script>